module.exports = __webpack_public_path__ + "img/9_62.a5d76898.png";